import { FC, ReactNode } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';

interface IEditButtonProps extends Omit<ButtonProps, 'size'> {
  /** Button text, defaults to "Edit". */
  label?: string;
  /** `small` for card headers, `medium` for page headers. */
  size?: 'small' | 'medium';
  /** Leading icon, defaults to the edit pencil (e.g. pass an Add icon for "Add" actions). */
  icon?: ReactNode;
}

/**
 * Green outlined action button used on page and card headers.
 */
const EditButton: FC<IEditButtonProps> = ({ label = 'Edit', size = 'medium', icon, sx, ...rest }) => (
  <Button
    variant='outlined'
    size='small'
    startIcon={icon ?? <EditIcon />}
    sx={{
      height: size === 'small' ? 28 : 32,
      px: size === 'small' ? 1.5 : 2,
      borderRadius: '6px',
      textTransform: 'none',
      fontSize: '13px',
      fontWeight: 500,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      bgcolor: '#fff',
      '&:hover': { bgcolor: '#fff' },
      '& .MuiButton-startIcon svg': { fontSize: '16px !important' },
      // MUI's default disabled state is a washed-out green that reads as broken; use a clear grey instead
      '&.Mui-disabled': { bgcolor: '#f5f6f8', borderColor: '#dcdcdc', color: '#9ca3af' },
      ...sx,
    }}
    {...rest}
  >
    {label}
  </Button>
);

export default EditButton;
